import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createCombinatoriaSchema = yup.object({
  modalidad_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  nivel_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  opcion_pedagogica_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
});
